import { cn } from '../../../lib/utils.ts'
import { type IllustrationProps } from '../illustration.types.ts'

export function MapIllustration({
  className,
  'aria-label': ariaLabel = 'Map',
  'aria-hidden': ariaHidden,
  ...rest
}: IllustrationProps): React.ReactElement {
  return (
    <svg
      viewBox="0 0 80 80"
      role="img"
      aria-label={ariaHidden === true ? undefined : ariaLabel}
      aria-hidden={ariaHidden}
      xmlns="http://www.w3.org/2000/svg"
      className={cn('inline-block shrink-0', className)}
      {...rest}
    >
      <>
        <defs>
          <linearGradient
            id="map-paint0_linear_16538_41536"
            x1={31.048}
            x2={19.242}
            y1={45.832}
            y2={62.307}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#58B558" />
            <stop offset={0.03} stopColor="#68BE68" />
            <stop offset={0.09} stopColor="#88CF88" />
            <stop offset={0.15} stopColor="#A3DEA3" />
            <stop offset={0.23} stopColor="#B9EAB9" />
          </linearGradient>
          <linearGradient
            id="map-paint1_linear_16538_41536"
            x1={45.23}
            x2={31.249}
            y1={33.484}
            y2={55.977}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#58B558" />
            <stop offset={0.29} stopColor="#68BE68" />
            <stop offset={1} stopColor="#88CF88" />
          </linearGradient>
          <linearGradient
            id="map-paint2_linear_16538_41536"
            x1={19.147}
            x2={70.784}
            y1={31.988}
            y2={59.109}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#20449A" />
            <stop offset={0.08} stopColor="#325EB4" />
            <stop offset={0.16} stopColor="#406ECA" />
            <stop offset={0.25} stopColor="#4B7BDB" />
            <stop offset={0.37} stopColor="#5384E7" />
            <stop offset={0.54} stopColor="#5789EE" />
            <stop offset={1} stopColor="#598BF0" />
          </linearGradient>
          <linearGradient
            id="map-paint3_linear_16538_41536"
            x1={17.612}
            x2={17.479}
            y1={16.244}
            y2={51.484}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D46953" />
            <stop offset={0.21} stopColor="#D1644E" />
            <stop offset={0.53} stopColor="#C85841" />
            <stop offset={0.91} stopColor="#BB3E25" />
            <stop offset={1} stopColor="#B8361C" />
          </linearGradient>
          <linearGradient
            id="map-paint4_linear_16538_41536"
            x1={20.903}
            x2={19.904}
            y1={41.755}
            y2={14.534}
            gradientUnits="userSpaceOnUse"
          >
            <stop />
            <stop offset={0.11} stopColor="#070201" />
            <stop offset={0.27} stopColor="#1C0804" />
            <stop offset={0.47} stopColor="#3E1209" />
            <stop offset={0.7} stopColor="#6D2010" />
            <stop offset={0.94} stopColor="#A93119" />
            <stop offset={1} stopColor="#B8361C" />
          </linearGradient>
          <linearGradient
            id="map-paint5_linear_16538_41536"
            x1={58.724}
            x2={57.584}
            y1={13.383}
            y2={41.038}
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D46953" />
            <stop offset={0.21} stopColor="#D1644E" />
            <stop offset={0.53} stopColor="#C85841" />
            <stop offset={0.91} stopColor="#BB3E25" />
            <stop offset={1} stopColor="#B8361C" />
          </linearGradient>
          <linearGradient
            id="map-paint6_linear_16538_41536"
            x1={60.978}
            x2={60.193}
            y1={34.067}
            y2={12.684}
            gradientUnits="userSpaceOnUse"
          >
            <stop />
            <stop offset={0.11} stopColor="#070201" />
            <stop offset={0.27} stopColor="#1C0804" />
            <stop offset={0.47} stopColor="#3E1209" />
            <stop offset={0.7} stopColor="#6D2010" />
            <stop offset={0.94} stopColor="#A93119" />
            <stop offset={1} stopColor="#B8361C" />
          </linearGradient>
        </defs>
        <g id="map-Insurance=-, Generic=Map">
          <g id="map-Group 244">
            <g id="map-Group" opacity={0.1}>
              <path
                id="map-Vector"
                fill="#000"
                d="m43.313 23.523 34.15 20.17-13.074 5.372-13.207 11.782-13.26 4.996-34.15-20.171 13.313-5.042 13.16-11.879z"
              />
            </g>
            <path
              id="map-Vector_2"
              fill="url(#map-paint0_linear_16538_41536)"
              d="m16.159 37.073-13.11 5.758 34.857 23.033 13.059-5.704z"
            />
            <path
              id="map-Vector_3"
              fill="#000"
              d="M37.927 66a.2.2 0 0 1-.084-.024L2.912 42.968a.15.15 0 0 1-.067-.14.16.16 0 0 1 .091-.126l13.138-5.752a.16.16 0 0 1 .145.012l34.882 23.062a.15.15 0 0 1 .067.14.16.16 0 0 1-.09.126L37.99 65.988a.14.14 0 0 1-.06.012zM3.311 42.868l34.631 22.808L50.7 60.121l-34.58-22.863-12.808 5.607z"
            />
            <path
              id="map-Vector_4"
              fill="url(#map-paint1_linear_16538_41536)"
              d="M28.855 23.529 16.117 37.078l34.894 23.069 12.792-13.444.094-.045z"
            />
            <path
              id="map-Vector_5"
              fill="#000"
              d="M51.006 60.283a.2.2 0 0 1-.085-.025l-34.873-23.05a.15.15 0 0 1-.066-.108.15.15 0 0 1 .039-.121L28.753 23.44a.15.15 0 0 1 .194-.024l35.018 23.11c.046.03.073.082.067.136a.16.16 0 0 1-.085.127l-.07.033-12.762 13.411a.16.16 0 0 1-.109.049M16.37 37.054l34.616 22.881L63.617 46.66 28.89 23.74 16.37 37.057z"
            />
            <path id="map-Vector_6" fill="#B9EAB9" d="m41.721 17.54-12.876 5.977 35 23.153 12.78-6.093z" />
            <path
              id="map-Vector_7"
              fill="#000"
              d="M63.837 46.8a.2.2 0 0 1-.085-.024L28.775 23.648a.14.14 0 0 1-.066-.136.15.15 0 0 1 .087-.127l12.868-5.968a.15.15 0 0 1 .149.012l34.88 23.013c.045.03.072.082.066.136a.15.15 0 0 1-.084.127l-12.772 6.086a.2.2 0 0 1-.063.015zM29.17 23.542 63.85 46.474l12.454-5.932-34.587-22.82z"
            />
            <path
              id="map-Vector_8"
              fill="url(#map-paint2_linear_16538_41536)"
              d="M49.536 41.853c-2.601-.557-4.794-.502-6.73-.45-2.843.072-5.087.13-7.95-1.55l-.022-.008c-.952-.956-1.514-1.945-2.036-2.88-.761-1.35-1.55-2.748-3.238-3.6-1.943-.984-3.936-1.19-5.697-1.37-.919-.098-1.773-.185-2.556-.367l-2.196 2.341c1.444.623 2.985.786 4.486.94 1.685.176 3.28.342 4.79 1.104.943.475 1.414 1.313 2.064 2.468 1.268 2.25 3.005 5.331 9.289 7.291 7.871 2.453 12.68 8.885 14.224 11.244l1.982-2.087c-1.692-2.51-5.682-7.575-12.026-10.618 1.562-.024 3.2.016 5.075.418 4.996 1.07 8.283 5.682 9.443 7.578l1.987-2.096c-1.586-2.467-5.262-7.148-10.895-8.355z"
            />
            <path
              id="map-Vector_9"
              fill="#205C20"
              d="M44.684 63.005a.16.16 0 0 1-.082-.024L16.906 44.815 5.814 41.728a.15.15 0 0 1-.106-.187.15.15 0 0 1 .188-.106l11.116 3.092.043.018 27.717 18.182c.07.045.088.139.042.209a.15.15 0 0 1-.127.07z"
            />
            <path
              id="map-Vector_10"
              fill="#fff"
              d="M46.677 28.225c1.278 0 2.314-.564 2.314-1.259 0-.696-1.036-1.26-2.314-1.26s-2.314.564-2.314 1.26c0 .695 1.036 1.26 2.314 1.26"
            />
            <path
              id="map-Vector_11"
              fill="#205C20"
              d="M46.677 28.361c-1.374 0-2.45-.614-2.45-1.395s1.076-1.395 2.45-1.395 2.45.614 2.45 1.395-1.077 1.395-2.45 1.395m0-2.486c-1.167 0-2.15.498-2.15 1.091s.983 1.091 2.15 1.091 2.15-.498 2.15-1.091-.984-1.091-2.15-1.091"
            />
            <path
              id="map-Vector_12"
              fill="#205C20"
              d="M24.844 50.005a.16.16 0 0 1-.139-.088.15.15 0 0 1 .076-.2l6.087-2.78 8.725-16.444a.12.12 0 0 1 .06-.06l5.03-2.802a.15.15 0 0 1 .205.058.153.153 0 0 1-.057.206l-4.99 2.78-8.728 16.45a.15.15 0 0 1-.07.067l-6.135 2.801a.2.2 0 0 1-.064.012"
            />
            <path
              id="map-Vector_13"
              fill="#205C20"
              d="M70.48 43.536a.2.2 0 0 1-.066-.015l-12.75-6.238-.039-.027-9.338-9.247a.15.15 0 0 1 0-.215.15.15 0 0 1 .215 0l9.32 9.232 12.728 6.226a.151.151 0 0 1-.067.287z"
            />
            <path
              id="map-Vector_14"
              fill="#000"
              d="M37.891 66a.2.2 0 0 1-.084-.024L2.912 42.958a.15.15 0 0 1-.067-.14.16.16 0 0 1 .09-.126l13.095-5.743 12.701-13.53s.03-.024.046-.033l12.873-5.97a.15.15 0 0 1 .148.013l34.895 23.018c.046.03.073.081.067.136a.15.15 0 0 1-.085.127L63.83 46.828 51.076 60.252s-.03.027-.048.033l-13.073 5.7a.14.14 0 0 1-.06.012zM3.311 42.858l34.595 22.818 12.97-5.654 12.75-13.424s.027-.024.046-.034l12.631-6.014-34.601-22.824-12.771 5.92-12.701 13.53s-.03.027-.049.037l-12.87 5.642z"
            />
            <path
              id="map-Vector_15"
              fill="#000"
              d="M63.748 46.874a.2.2 0 0 1-.085-.024L28.775 23.67a.15.15 0 0 1 .166-.252L63.83 46.6a.15.15 0 0 1-.085.275z"
            />
            <path
              id="map-Vector_16"
              fill="#000"
              d="M51.02 60.283a.2.2 0 0 1-.085-.024L16.048 37.213a.15.15 0 1 1 .166-.25l34.887 23.045a.15.15 0 0 1 .043.208.15.15 0 0 1-.127.067z"
            />
            <g id="map-Group_2" fill="#226322" opacity={0.2}>
              <path
                id="map-Vector_17"
                d="M27.622 24.868 16.15 37.083l-.402.175c.728 3.06 1.602 5.45 1.602 5.45s6.393-4.721 9.212-8.867c2.226-3.275 2.374-6.623 1.059-8.976z"
              />
              <path
                id="map-Vector_18"
                d="M17.35 42.862s-.03 0-.041-.006a.15.15 0 0 1-.1-.094 55 55 0 0 1-1.61-5.467.146.146 0 0 1 .089-.173l.375-.163 11.45-12.194a.14.14 0 0 1 .126-.045c.049.006.09.033.115.076 1.455 2.598 1.055 6.012-1.064 9.133-2.8 4.122-9.182 8.857-9.248 8.903a.16.16 0 0 1-.091.03m-1.427-5.516a56 56 0 0 0 1.5 5.12c1.017-.768 6.49-4.999 9.013-8.707 2.005-2.951 2.428-6.16 1.149-8.634l-11.329 12.06s-.03.028-.048.037l-.287.124z"
              />
            </g>
            <g id="map-Group_3" fill="#226322" opacity={0.2}>
              <path id="map-Vector_19" d="M60.963 30.257s-2.746 4.576-2.75 4.576c0 0 3.055-1.712 4.921-3.176z" />
              <path
                id="map-Vector_20"
                d="M58.214 34.987a.14.14 0 0 1-.105-.045.15.15 0 0 1-.022-.188l2.746-4.572a.14.14 0 0 1 .097-.07c.04-.009.082 0 .115.021l2.171 1.4a.15.15 0 0 1 .07.122.16.16 0 0 1-.058.127c-1.778 1.394-4.614 3.006-4.932 3.184a.15.15 0 0 1-.079.021zm2.798-4.515-2.368 3.944c.92-.533 2.849-1.688 4.23-2.746l-1.862-1.2z"
              />
            </g>
            <path
              id="map-Vector_21"
              fill="url(#map-paint3_linear_16538_41536)"
              d="M17.606 17.439c-4.25-1.25-6.932 1.388-7.002 6.398-.09 6.324 6.762 18.885 6.762 18.885s5-5.742 6.596-10.785c2.023-6.4-1.372-13.031-6.353-14.495zm-.16 15.172c-2.378-1.464-4.304-5.3-4.304-8.565s1.926-4.725 4.303-3.261 4.303 5.3 4.303 8.565-1.926 4.726-4.303 3.261"
            />
            <path
              id="map-Vector_22"
              fill="url(#map-paint4_linear_16538_41536)"
              d="M20.56 16.614c-3.855-.961-7.642 1.381-7.642 1.381 1.177-.867 2.761-1.094 4.663-.532 4.964 1.463 8.344 8.09 6.331 14.483-1.587 5.042-6.573 10.777-6.573 10.777s7.962-6.584 9.552-11.626c2.016-6.394-1.367-13.02-6.332-14.483"
            />
            <path
              id="map-Vector_23"
              fill="#000"
              d="M19.206 33.33c-.579 0-1.206-.2-1.843-.59-2.413-1.49-4.378-5.39-4.378-8.7 0-1.788.58-3.138 1.589-3.7.828-.464 1.877-.352 2.95.308 2.413 1.49 4.377 5.39 4.377 8.699 0 1.788-.579 3.139-1.588 3.701-.337.188-.71.282-1.107.282m-1.685-.85c.976.602 1.913.708 2.64.302.91-.508 1.434-1.761 1.434-3.438 0-3.215-1.9-7.001-4.235-8.442-.976-.602-1.913-.708-2.64-.303-.91.509-1.435 1.762-1.435 3.439 0 3.214 1.901 7 4.236 8.441"
            />
            <path
              id="map-Vector_24"
              fill="#000"
              d="M19.303 31.385c-2.378-1.47-4.304-5.32-4.304-8.595 0-1.075.21-1.953.573-2.596-1.448.06-2.45 1.472-2.45 3.835 0 3.279 1.926 7.126 4.303 8.595 1.596.987 2.986.647 3.728-.677-.56.024-1.187-.152-1.853-.562z"
            />
            <path
              id="map-Vector_25"
              fill="#000"
              d="M19.173 33.324c-.577 0-1.199-.2-1.83-.59-2.402-1.49-4.358-5.392-4.358-8.701 0-2.35 1.014-3.912 2.587-3.975a.15.15 0 0 1 .136.227c-.363.642-.553 1.513-.553 2.515 0 3.216 1.893 7.003 4.217 8.444.613.378 1.204.563 1.76.539a.15.15 0 0 1 .136.227c-.366.654-.891 1.084-1.519 1.247q-.28.073-.58.073zM15.318 20.39c-1.258.215-2.03 1.58-2.03 3.645 0 3.215 1.892 7.005 4.216 8.443.778.482 1.53.648 2.176.482.47-.121.881-.424 1.192-.881-.534-.034-1.09-.227-1.657-.579-2.403-1.49-4.358-5.392-4.358-8.7 0-.93.16-1.756.461-2.41"
            />
            <path
              id="map-Vector_26"
              fill="url(#map-paint5_linear_16538_41536)"
              d="M58.404 14.99c-3.316-.98-5.41 1.09-5.465 5.022-.072 4.96 5.278 14.815 5.278 14.815s3.904-4.503 5.148-8.462c1.577-5.022-1.07-10.224-4.958-11.372zm-.127 11.904c-1.853-1.15-3.358-4.158-3.358-6.719s1.505-3.708 3.358-2.558 3.358 4.16 3.358 6.72-1.504 3.707-3.358 2.557"
            />
            <path
              id="map-Vector_27"
              fill="url(#map-paint6_linear_16538_41536)"
              d="M60.68 14.36c-1.846-.541-4.78-.061-5.971 1.027l.009.054c.93-.68 2.18-.858 3.681-.417 3.919 1.149 6.588 6.343 4.997 11.354-1.255 3.953-5.188 8.45-5.188 8.45s6.214-5.162 7.469-9.115c1.588-5.014-1.078-10.208-4.997-11.354"
            />
            <path
              id="map-Vector_28"
              fill="#000"
              d="M59.656 27.473c-.458 0-.952-.156-1.454-.466-1.888-1.165-3.426-4.219-3.426-6.81 0-1.407.458-2.47 1.255-2.912.657-.364 1.481-.28 2.33.244 1.888 1.164 3.426 4.218 3.426 6.809 0 1.408-.458 2.47-1.256 2.916-.267.15-.562.222-.875.222zm-1.295-.722c.75.464 1.47.548 2.026.235.698-.388 1.099-1.357 1.099-2.651 0-2.497-1.472-5.437-3.281-6.553-.75-.464-1.47-.545-2.023-.235-.698.388-1.099 1.357-1.099 2.65 0 2.498 1.472 5.438 3.281 6.554z"
            />
            <path
              id="map-Vector_29"
              fill="#000"
              d="M59.73 25.932c-1.852-1.148-3.354-4.15-3.354-6.706 0-.84.163-1.523.446-2.027-1.13.045-1.91 1.148-1.91 2.99 0 2.56 1.503 5.562 3.355 6.707 1.243.77 2.327.504 2.908-.529-.437.018-.928-.118-1.445-.438z"
            />
            <path
              id="map-Vector_30"
              fill="#000"
              d="M59.683 27.538c-.461 0-.955-.157-1.458-.466-1.9-1.173-3.449-4.249-3.449-6.858 0-1.863.812-3.1 2.067-3.151q.089 0 .136.073a.15.15 0 0 1 0 .154c-.281.5-.43 1.176-.43 1.958 0 2.515 1.482 5.475 3.303 6.6.476.293.937.439 1.367.418q.089 0 .137.072c.03.049.03.106 0 .155-.294.521-.716.864-1.216.994q-.224.058-.466.057zm-3.091-10.142c-.94.2-1.51 1.249-1.51 2.815 0 2.515 1.482 5.476 3.304 6.6.606.373 1.19.503 1.688.376.348-.091.651-.306.888-.63q-.612-.055-1.261-.455c-1.9-1.173-3.449-4.248-3.449-6.858 0-.706.118-1.339.34-1.848"
            />
            <path
              id="map-Vector_31"
              fill="#000"
              d="M58.2 34.96h-.027a.15.15 0 0 1-.106-.075c-.221-.401-5.402-9.916-5.332-14.844.03-2.124.674-3.772 1.815-4.653 0-.036.021-.072.048-.1 1.217-1.107 4.185-1.62 6.113-1.059 1.784.522 3.392 1.913 4.412 3.815 1.25 2.332 1.5 5.145.683 7.713-1.241 3.91-7.253 8.956-7.508 9.17a.15.15 0 0 1-.1.036zm-3.335-19.502c0 .045-.024.09-.06.117-1.108.812-1.733 2.4-1.764 4.47-.063 4.502 4.51 13.228 5.208 14.532.984-.839 6.149-5.371 7.272-8.91.792-2.493.549-5.221-.662-7.482-.98-1.831-2.522-3.168-4.23-3.666-1.776-.519-4.592-.054-5.764.938m4.786 12.04c-.46 0-.959-.157-1.462-.468-1.903-1.168-3.454-4.23-3.454-6.829 0-1.412.461-2.477 1.266-2.92.661-.366 1.496-.281 2.348.244 1.903 1.167 3.454 4.23 3.454 6.828 0 1.413-.461 2.478-1.265 2.924-.27.151-.568.224-.884.224zm-2.77-10.14q-.4 0-.738.185c-.704.389-1.108 1.36-1.108 2.658 0 2.505 1.484 5.453 3.308 6.573.756.464 1.481.549 2.04.235.704-.39 1.107-1.361 1.107-2.659 0-2.504-1.484-5.452-3.308-6.572-.455-.28-.9-.422-1.305-.422z"
            />
            <path
              id="map-Vector_32"
              fill="#fff"
              d="M34.086 57.016c1.278 0 2.314-.549 2.314-1.225 0-.677-1.036-1.225-2.314-1.225s-2.315.548-2.315 1.225c0 .676 1.036 1.225 2.315 1.225"
            />
            <path
              id="map-Vector_33"
              fill="#205C20"
              d="M34.086 57.152c-1.374 0-2.45-.6-2.45-1.361 0-.763 1.076-1.362 2.45-1.362s2.45.6 2.45 1.362-1.076 1.36-2.45 1.36m0-2.426c-1.167 0-2.15.486-2.15 1.065 0 .578.983 1.064 2.15 1.064s2.15-.486 2.15-1.064-.984-1.065-2.15-1.065"
            />
            <g id="map-Group_4" fill="#226322" opacity={0.2}>
              <path
                id="map-Vector_34"
                d="M17.146 45.551c1.353 0 2.45-.389 2.45-.868 0-.48-1.097-.868-2.45-.868s-2.45.389-2.45.868c0 .48 1.097.868 2.45.868"
              />
              <path
                id="map-Vector_35"
                d="M17.146 45.702c-1.262 0-2.601-.357-2.601-1.019s1.34-1.02 2.6-1.02c1.262 0 2.601.358 2.601 1.02s-1.34 1.02-2.6 1.02m0-1.736c-1.425 0-2.299.418-2.299.717 0 .3.874.717 2.299.717s2.298-.418 2.298-.717c0-.3-.874-.717-2.298-.717"
              />
            </g>
            <g id="map-Group_5" fill="#226322" opacity={0.2}>
              <path
                id="map-Vector_36"
                d="M57.75 37.646c.88 0 1.592-.252 1.592-.563s-.712-.562-1.591-.562-1.59.251-1.59.562c0 .31.711.563 1.59.563"
              />
              <path
                id="map-Vector_37"
                d="M57.75 37.797c-.864 0-1.741-.245-1.741-.714 0-.94 3.484-.937 3.484 0 0 .469-.877.714-1.742.714m0-1.125c-.93 0-1.439.272-1.439.411 0 .14.508.412 1.44.412s1.44-.273 1.44-.412-.509-.411-1.44-.411"
              />
            </g>
            <path
              id="map-Vector_38"
              fill="#000"
              d="M17.37 42.853h-.027a.15.15 0 0 1-.102-.076c-.07-.127-6.863-12.642-6.772-18.92.042-2.901.967-5.078 2.61-6.13a5 5 0 0 1 .502-.274c.203-.094.402-.17.608-.23 1.579-.67 3.992-1.35 6.448-.74h.006c2.257.665 4.292 2.431 5.58 4.85 1.583 2.968 1.9 6.543.866 9.81-1.588 5.021-9.292 11.414-9.618 11.682a.16.16 0 0 1-.097.034zm1.265-26.315c-1.673 0-3.221.48-4.35.96a4.3 4.3 0 0 0-1.034.471c-1.564 1.003-2.44 3.092-2.48 5.888-.085 5.813 5.85 17.118 6.648 18.61 1.077-.913 7.94-6.855 9.383-11.423 1.007-3.192.701-6.683-.844-9.578-1.252-2.346-3.219-4.058-5.396-4.698a8 8 0 0 0-1.92-.23zm.578 16.791c-.578 0-1.204-.199-1.84-.589-2.407-1.485-4.367-5.377-4.367-8.677 0-1.785.578-3.132 1.585-3.693.826-.462 1.872-.35 2.943.308 2.408 1.485 4.368 5.377 4.368 8.678 0 1.784-.578 3.13-1.585 3.692a2.24 2.24 0 0 1-1.104.281m-3.521-12.938c-.345 0-.668.078-.956.242-.907.507-1.43 1.757-1.43 3.43 0 3.206 1.896 6.984 4.225 8.42.974.602 1.909.707 2.635.303.907-.508 1.43-1.758 1.43-3.43 0-3.207-1.896-6.984-4.225-8.422-.587-.362-1.159-.543-1.679-.543"
            />
          </g>
        </g>
      </>
    </svg>
  )
}
